import { StyleObject } from 'styletron-react';

export const focusRing: StyleObject = {
	// using boxShadow instead of outline makes "focus-ring" follow
	// the button's border radius.
	boxShadow: '0 0 0 2.01px var(--epods--color-bg), 0 0 0 4.01px var(--epods--color-bg-primary) !important',
	// boxShadow: 'inset 0 0 0 2px rgba(255, 255, 255, 1.00), inset 0 0 0 4px var(--epods--color-bg-primary)',

	// keep transparent outline so it is visible on Windows High-Contrast Mode.
	// https://sarahmhigley.com/writing/whcm-quick-tips/
	outline: '2px solid transparent !important',
	outlineOffset: 0,
	zIndex: 1,
};

export const focusRingOutline: StyleObject = {
	outlineWidth: '2.01px !important',
	outlineStyle: 'solid  !important',
	outlineColor: 'var(--epods--color-border-focus)  !important',
	outlineOffset: 0,
};

export const focusRingNoGap: StyleObject = {
	// using boxShadow instead of outline makes "focus-ring" follow
	// the button's border radius.
	boxShadow: '0 0 0px 2.01px var(--epods--color-bg-primary) !important',
	// boxShadow: 'inset 0 0 0 2px rgba(255, 255, 255, 1.00), inset 0 0 0 4px var(--epods--color-bg-primary)',

	// keep transparent outline so it is visible on Windows High-Contrast Mode.
	// https://sarahmhigley.com/writing/whcm-quick-tips/
	outline: '2.01px solid transparent !important',
	outlineOffset: 0,
	zIndex: 1,
};

export const focusRingInset: StyleObject = {
	// using boxShadow instead of outline makes "focus-ring" follow
	// the button's border radius.
	boxShadow: '0 0 0px 2.01px var(--epods--color-bg-primary) inset !important',
	// boxShadow: 'inset 0 0 0 2px rgba(255, 255, 255, 1.00), inset 0 0 0 4px var(--epods--color-bg-primary)',

	// keep transparent outline so it is visible on Windows High-Contrast Mode.
	// https://sarahmhigley.com/writing/whcm-quick-tips/
	outline: '2.01px solid transparent !important',
	outlineOffset: 0,
	zIndex: 1,
};
